import { useQuery } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';
import { UserAudio } from '../../@types';

type Payload = {
  id: string;
};

const getAudioById = async (payload: Payload): Promise<UserAudio> => {
  const res = await axiosInstance.get(`/api/audios/${payload.id}`);
  return res.data;
};

export const useGetAudioById = (payload: Payload) => {
  return useQuery(['getAudioById', payload], () => getAudioById(payload));
};
